import Xsvg from "./Xsvg";
const TraPanel = () => {
	return <div className="z-[5] absolute w-screen h-screen "></div>;
};

export default TraPanel;
